export default __webpack_public_path__ + "static/media/43.9ec45aec.svg";